import { useContext } from 'react'
import { object } from 'prop-types'
import { components } from '@digital-commerce/shared-utils'

import { StackView, Typography, Icon, Box } from '@telus-uds/components-web'
import Delivery from '@telus-uds/palette-allium/build/web/icons/Delivery'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

import {
  getRTISla,
  isBackordered,
  isCached,
  isOutOfStock,
  isRTI,
  isRTIAvailable
} from '../../../utils/rti'

const { ShouldRender, WithLegal } = components

const ShippingSla = ({ inventory }) => {
  const device = { inventory }
  const translate = useTranslate()
  const { lang } = useContext(localeContext)
  const t = (path) => translate(`mobilitySLA.${path}`)

  if (isOutOfStock(device) || !isRTI(device)) return null

  const date = getRTISla(device, lang)
  const cacheStatus = isCached(device) ? 'cache' : 'realTime'
  const copy = isRTIAvailable(device) ? `${t(cacheStatus)} ${date}` : t('isUnknown')

  return (
    <StackView space={2} direction="row" testID="status">
      <Icon icon={Delivery} variant={{ size: 'small' }} />
      <Box testID="inventory-sla">
        <ShouldRender when={isBackordered(device)}>
          <Typography variant={{ size: 'small', bold: true }}>{t('backorder')}</Typography>
        </ShouldRender>
        <Typography variant={{ size: 'small' }}>
          {copy} <WithLegal content={t('terms')} copy={lang} />
        </Typography>
      </Box>
    </StackView>
  )
}

export default ShippingSla

ShippingSla.propTypes = {
  inventory: object
}

ShippingSla.defaultProps = {
  inventory: {}
}
